//FormulaBuilder components
import elementTypes from "../Elements/elementTypes"
import FormulaBuilderDragIcon from "./FormulaBuilderDragIcon"
import formulaBuilderTypes from "./formulaBuilderTypes"

//PrimeReact
import { Tooltip } from "primereact/tooltip"

//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormulaBuilder.module.css"

export default function FormulaBuilderQuestionOrderEntry({ entry }) {
  let typeProfile = undefined
  let name = "Unknown entry"
  let textTooltip = undefined

  if (entry.question) {
    typeProfile = elementTypes.findTypeProfile(entry.question.type)
    name = entry.question?.text
  } else if (entry.questionGroup) {
    name = entry.questionGroup.name
    typeProfile = elementTypes.findTypeProfile(elementTypes.groupElementId)
  }

  if (name?.length > 100) {
    name = name?.substring(0, 100) + "..."
    textTooltip = name
  }

  if (!typeProfile?.allowFormula) {
    return null
  }

  return (
    <>
      <div className={`${myStyles.questionLayout} ${myStyles.container}`}>
        <Tooltip
          target={".tt-numberType"}
          className={myStyles.numberToolTip}
          position="left"
        />
        <div
          className={`${myStyles.questionLayoutIcon} tt-numberType`}
          data-pr-tooltip={typeProfile?.label}
        >
          <span className="material-icons">{typeProfile?.icon}</span>
        </div>
        <div
          className={`${myStyles.questionLayoutText}  tt-numberType`}
          data-pr-tooltip={textTooltip}
          data-pr-position="bottom"
        >
          {name}
        </div>

        <div className={myStyles.questionLayoutDragIcon}>
          <FormulaBuilderDragIcon
            id={entry.id}
            type={formulaBuilderTypes.formulaTypes.question}
            object={entry}
          />
        </div>
      </div>
      {entry.questionGroup &&
        entry.questionGroup.questions.map((question) => {
          return (
            <FormulaBuilderQuestionOrderEntry
              key={question.id}
              entry={{ question: question }}
            />
          )
        })}
    </>
  )
}
